import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { EventAction } from "@directives/_vehicle/journeySummary/journeySummary.component";
import { ExternalReferenceService } from "@directives/_veri/externalReference/externalReference.service";
import { IVeriNavPill } from "@directives/_veri/veriPills/veriPills.component";
import { AccountUserType } from "@enums/UserType";
import { ICombinedPreferences } from "@interfaces/ICombinedPreferences";
import { GeofenceCategory, IGeofence } from "@interfaces/IGeofences";
import { IUser } from "@interfaces/IUser";
import { CurrentUserService } from "@services/currentUser.service";
import { GeocodeService, IGeocodeResult, IViewPort } from "@services/geocode.service";
import { GeofenceService, IGeofenceVisit } from "@services/geofence.service";
import { SessionService } from "@services/session.service";
import { TranslationService } from "@services/translation.service";
import { VeriDate } from "@services/veriDate.service";
import { StateService } from "@uirouter/angularjs";
import * as angular from "angular";
import "angular-material";
import { SettingsName } from "src/app/class/SettingsName";
import "./resourceGeofences.scss";

class Controller {

    // enums
    GeofenceCategory = GeofenceCategory;

    // geofences
    geofences: IGeofence[];
    filteredGeofences: IGeofence[];

    // selected geofence
    selectedGeofence: IGeofence;
    selectedGeofenceAddress: string;
    selectedGeofenceTab: string;
    selectedGeofenceLastVisit: IGeofenceVisit;
    selectedGeofenceCurrentlyActiveVisits: IGeofenceVisit[] = [];
    showCurrentlyActiveVisits: boolean = false;

    // loaders
    loadingGeofences: boolean = false;
    loadingNavPoints: boolean = false;

    // map
    veriMap: IVeriMapComponent;
    showingZones: boolean = false;
    mapBounds: IViewPort;

    // tabs
    navPills: IVeriNavPill<IGeofence[]>[];
    tabIndex: number = 0;

    // other
    currentUser: IUser

    static $inject = ["$scope", "$state","$q", "$mdDialog", "$timeout", "geofenceService", "externalReferenceService", "geocodeService", "veriDate", "translationService", "sessionService","currentUserService"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly $state: StateService,
        private readonly $q: angular.IQService,
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly $timeout: angular.ITimeoutService,
        private readonly geofenceService: GeofenceService,
        private readonly externalReferenceService: ExternalReferenceService,
        private readonly geocodeService: GeocodeService,
        private readonly veriDate: VeriDate,
        private readonly translationService: TranslationService,
        private readonly sessionService: SessionService,
        private readonly currentUserService: CurrentUserService) {
    }

    $onInit() {
        this.createTabs();
        this.currentUser = this.currentUserService.getCurrentUserFromCache();
    }

    addGeofenceAtPosition(position: google.maps.LatLng) {
        this.showGeofenceEditorDialog(null, position);
    }

    deleteGeofence(geofence: IGeofence): void {
        this.loadingGeofences = true;

        this.geofenceService
            .deleteGeofence(geofence)
            .then(() => {
                this.loadGeofences();
            });
    }

    geofenceMouseEvent(geofence: IGeofence, eventAction: EventAction) {
        if (this.selectedGeofence && geofence.Id === this.selectedGeofence.Id) {
            this.clearSelectedGeofence();
            return;
        }

        if (eventAction === EventAction.Selected) {
            this.setSelectedGeofence(geofence);
        }
    }

    importGeofences($event: MouseEvent) {
        const dialogOptions: angular.material.IDialogOptions = {
            targetEvent: $event,
            escapeToClose: true,
            clickOutsideToClose: false,
            template: require("../../csvImporter/geofenceImporter/geofenceImporter.dialog.html"),
            controller: "geofenceImporterController",
            controllerAs: "$ctrl"
        };

        this.$mdDialog.show(dialogOptions).then(() => { });
    }

    mapGeofenceClicked(geofence: IGeofence) {
        if (this.selectedGeofence && this.selectedGeofence.Id === geofence.Id) {
            return;
        }

        this.setSelectedGeofence(geofence);
    }

    mainMapLoaded(veriMap: IVeriMapComponent) {
        this.veriMap = veriMap;

        let getPointFromAddressPromise: angular.IPromise<IGeocodeResult[]>
        if (!this.mapBounds) {

            var userOptions = this.sessionService.getItem<ICombinedPreferences>(SettingsName.UserOptions);
            getPointFromAddressPromise = this.geocodeService.getPointFromAddress(userOptions.CountryCode.Value, true)
        }
        else {
            let geocode: IGeocodeResult = {
                address_components: null,
                formatted_address: null,
                place_id: null,
                types:null,
                geometry: {
                    location: null,
                    location_type:null,
                    bounds: this.mapBounds,
                    viewport: this.mapBounds
                }
            };
            getPointFromAddressPromise = this.$q.resolve([geocode]);
        }

        this.$q.all([getPointFromAddressPromise])
            .then(([pointsFromAddress]) => {


                if (pointsFromAddress?.length > 0) {

                    this.mapBounds = pointsFromAddress[0].geometry.viewport;
                }
                else {
                    this.mapBounds = {
                        northeast: { lat: 55.811741, lng: 1.76896 },
                        southwest: { lat: 28.418966, lng: -92.859797}
                    }
                }

                if (this.geofences?.length || this.selectedGeofence) {
                    this.geofenceService.fitMapToGeofences(veriMap, this.selectedGeofence, this.geofences.filter(x => this.mapCenterValidateGeofence(x)), this.mapBounds);

                    return;
                }

                this.loadGeofences().finally(() => {

                    // creates a new geofence from right click popup
                    if (this.$state.params["position"]) {
                        this.addGeofenceAtPosition(this.$state.params["position"]);
                    }

                    //sets the selected geofence to edit from livemap
                    if (this.$state.params["geofence"]) {
                        this.geofences.forEach(geofence => {
                            if (this.$state.params["geofence"] == geofence.Id) {
                                this.setSelectedGeofence(geofence);
                            }
                        });
                    }

                    //sets the selected geofence to view visits from live map
                    if (this.$state.params["visits"]) {
                        this.geofences.forEach(geofence => {
                            if (this.$state.params["visits"] == geofence.Id) {
                                this.setSelectedGeofence(geofence);
                            }
                        });
                    }

                    this.geofenceService.fitMapToGeofences(veriMap, this.selectedGeofence, this.geofences.filter(x => this.mapCenterValidateGeofence(x)), this.mapBounds);
                });

              
            });
    }

    preventEditingSystemOrRestrictedGeofences(): void {
        this.geofences?.forEach(geofence => {
            geofence.isSystemGeofence = !geofence?.AccountId;
            geofence.isRestrictedReadOnly = geofence.Restricted && this.currentUser.CurrentAccountUserMapping.Type !== AccountUserType.Admin
            geofence.isReadOnly = geofence.isSystemGeofence || (geofence?.Shapes?.length > 1) || geofence.isRestrictedReadOnly;
        });
    }

    mainMapUnloaded() {
        this.veriMap = null;
    }

    //onMainTabChanged(tabIndex: number, tabTitle: string) {
    //    this.selectedNavLabel = this.navLabels.find(l => l.label == tabTitle);
    //    this.selectedNavLabelIndex = this.navLabels.indexOf(this.selectedNavLabel);
    //    this.filterGeofencesForTab();

    //    this.$timeout(() => {
    //        this.clearSelectedGeofence();
    //    }, 100);
    //}

    onGeofenceTabChanged(tabIndex: number, tabTitle: string) {
        this.selectedGeofenceTab = tabTitle;
    }

    showGeofenceEditorDialog(
        geofence: IGeofence = null,
        position: google.maps.LatLng = null,
        $event: MouseEvent = null) {

        this.geofenceService.showGeofenceEditor(geofence, $event, {
            focusedLatLngs: position,
            onGeofenceEditorCancelled: () => { this.onGeofenceEditorCancelled(); },
            onGeofenceEditorSaved: (savedGeofence: IGeofence) => { this.onGeofenceEditorSaved(savedGeofence); },
            onGeofenceEditorDeleted: (deletedGeofence: IGeofence) => { this.onGeofenceEditorDeleted(deletedGeofence); }
        });
    }

    setShowingZonesValue(show: boolean): void {
        this.showingZones = show;

        if (!this.showingZones) {
            this.clearSelectedGeofenceIfIsZone();
        }
    }

    onNavPillSelected(selectedNavPill: IVeriNavPill<IGeofence[]>, dontUseApply = false) {
        this.tabIndex = this.navPills.indexOf(selectedNavPill);

        this.filteredGeofences = selectedNavPill.data;

        if (!dontUseApply) {
            // Needed for Hybrid apps
            this.$scope.$apply();
        }
    }

    // -------

    private createTabs(): void {
        this.navPills = []
        this.navPills.push({ title: this.translationService.t("Common.All"), count: 0, selected: true });
        this.navPills.push({ title: this.translationService.t("Common.Geofences"), count: 0 });
        this.navPills.push({ title: this.translationService.t("Common.Zones"), count: 0 });

        //this.switchToNavLabel(this.navLabels[0]);
        this.updateGeofenceCount();
    }

    private updateGeofenceCount() {

        if (!this.geofences) {
            return;
        }

        this.navPills[0].data = this.geofences;
        this.navPills[0].count = this.navPills[0].data.length;

        this.navPills[1].data = this.geofences.filter(geofence => geofence?.Category === GeofenceCategory.Standard);
        this.navPills[1].count = this.navPills[1].data.length;

        this.navPills[2].data = this.geofences.filter(geofence => geofence?.Category === GeofenceCategory.Zone);
        this.navPills[2].count = this.navPills[2].data.length;
    }

    //private switchToGeofencesTab(): void {
    //    this.switchToNavLabel(this.navLabels[0]);
    //}

    //private switchToZonesTab(): void {
    //    this.switchToNavLabel(this.navLabels[1]);
    //}

    //private switchToNavLabel(label: IVeriPillNavLabel) {
    //    if (!label) {
    //        return;
    //    }

    //    this.selectedNavLabel = label;
    //    this.selectedNavLabelIndex = this.navLabels.indexOf(label);

    //    this.filterGeofencesForTab();
    //}

    //private filterGeofencesForTab() {
    //    if (!this.geofences?.length) {
    //        this.filteredGeofences = [];

    //        return;
    //    }

    //    switch (this.tabIndex) {
    //        case 0:
    //            this.filteredGeofences = this.geofences.filter(geofence => geofence?.Category === GeofenceCategory.Standard);
    //            break;
    //        case 1:

    //            this.filteredGeofences = this.geofences.filter(geofence => geofence?.Category === GeofenceCategory.Zone);
    //            break;
    //    }
    //}

    private clearSelectedGeofenceIfIsZone(): void {
        if (this.selectedGeofence?.Category === GeofenceCategory.Zone) {
            this.clearSelectedGeofence();
        }
    }

    private onGeofenceEditorCancelled(): void { }

    private onGeofenceEditorSaved(savedGeofence: IGeofence): void {
        this.$timeout(() => {
            this.loadGeofences().finally(() => {
                //if (savedGeofence?.Category === GeofenceCategory.Zone) {
                //    this.onNavPillSelected(this.navPills[2]);

                //}
                //else if (savedGeofence?.Category === GeofenceCategory.Standard) {
                //    this.onNavPillSelected(this.navPills[1]);
                //}

                this.selectGeofenceById(savedGeofence?.Id);
            });
        }, 1000);
    }

    private onGeofenceEditorDeleted(deletedGeofence: IGeofence): void {
        this.$timeout(() => {
            this.loadGeofences();
        }, 1000);
    }

    private loadGeofences(invalidateCache = false): angular.IPromise<IGeofence[]> {
        this.loadingGeofences = true;

        this.clearSelectedGeofence();

        return this.geofenceService
            .getGeofences({ invalidateCache, includeTags: true })
            .then(geofences => {

                return this.externalReferenceService.getAllGeofenceExternalReferences(invalidateCache).then(externalReferenceList => {
                    this.geofences = geofences;

                    this.geofences.forEach(geofence => {
                        var externalReferences = externalReferenceList.filter(ref => ref.GeofenceId === geofence.Id);
                        if (externalReferences) {
                            geofence.externalReferences = externalReferences;
                        }
                    });

                    this.loadingGeofences = false;

                    return this.geofences;
                });
            }).finally(() => {
                this.preventEditingSystemOrRestrictedGeofences();
                //this.filterGeofencesForTab();
                this.updateGeofenceCount();
                this.onNavPillSelected(this.navPills[this.tabIndex], true);
            });
    }

    private selectGeofenceById(geofenceId?: number): void {
        if (!geofenceId) {
            return;
        }

        this.setSelectedGeofence(this.geofences.find(geofence => geofence.Id === geofenceId));
    }

    private clearSelectedGeofence(): void {
        this.selectedGeofence = null;
    }

    private setSelectedGeofence(geofence?: IGeofence, fitMap: boolean = true) {
        if (!geofence || geofence === this.selectedGeofence) {
            this.clearSelectedGeofence();
            return;
        }

        this.loadingNavPoints = true;

        this.geofenceService.getGeofenceNavigationPoints(geofence.Id).then(response => {
            geofence.navigationPoints = response;

            this.selectedGeofence = angular.copy(geofence);

            this.updateSelectedGeofenceAddress();
        }).finally(() => {
            this.loadingNavPoints = false;

            if (fitMap) {
                this.geofenceService.fitMapToGeofences(this.veriMap, this.selectedGeofence, this.geofences);
            }

            this.getLatestAndCurrentGeofenceVisits(geofence);
        });
    }

    getLatestAndCurrentGeofenceVisits(geofence: IGeofence) {
        this.resetVisitsCounts();
        this.geofenceService
            .getGeofenceVisitsByGeofence(geofence.Id, this.veriDate.createMoment(new Date()).add(-6, 'months'), this.veriDate.createMoment(new Date()))
            .then(visits => {
                if (!visits.length) {
                    return;
                }

                this.setLatestVisit(visits);

                this.setActiveVisits(visits);


                if (this.selectedGeofenceCurrentlyActiveVisits.length > 1 ||
                    (this.selectedGeofenceCurrentlyActiveVisits.length === 1 && this.selectedGeofenceCurrentlyActiveVisits[0] !== this.selectedGeofenceLastVisit)) {
                    this.showCurrentlyActiveVisits = true;
                }
            })
    }

    private setActiveVisits(visits: IGeofenceVisit[]) {
        this.selectedGeofenceCurrentlyActiveVisits = visits.filter(visit => {
            return !visit.EndUtc && visit.vehicle && visit !== this.selectedGeofenceLastVisit;
        })
        
        this.selectedGeofenceCurrentlyActiveVisits.forEach(visit => {
            visit.duration = this.veriDate.formatDuration(this.veriDate.createMoment(visit.StartUtc), this.veriDate.createMoment(visit.EndUtc));
        });
    }

    private setLatestVisit(visits: IGeofenceVisit[]) {
        this.selectedGeofenceLastVisit = visits.reverse()[0];
        this.selectedGeofenceLastVisit.duration = this.veriDate.formatDuration(this.veriDate.createMoment(this.selectedGeofenceLastVisit.StartUtc), this.veriDate.createMoment(this.selectedGeofenceLastVisit.EndUtc));
    }

    private resetVisitsCounts() {
        this.showCurrentlyActiveVisits = false;
        this.selectedGeofenceLastVisit = null;
        this.selectedGeofenceCurrentlyActiveVisits = [];
    }

    private updateSelectedGeofenceAddress(): void {
        if (!this.selectedGeofence) {
            return;
        }

        this.selectedGeofenceAddress = `${this.selectedGeofence.Addr1}`;

        if (this.selectedGeofence.Addr2) {
            this.selectedGeofenceAddress += `, ${this.selectedGeofence.Addr2}`;
        }

        if (this.selectedGeofence.Addr3) {
            this.selectedGeofenceAddress += `, ${this.selectedGeofence.Addr3}`;
        }

        if (this.selectedGeofence.Addr4) {
            this.selectedGeofenceAddress += `, ${this.selectedGeofence.Addr4}`;
        }
    }

    private onExternalIdDialogClose(): void {
        this.updateExteranlIds();
    }

    private updateExteranlIds(invalidateCache = false): void {
        this.loadingGeofences = true;

        this.externalReferenceService
            .getAllGeofenceExternalReferences(invalidateCache)
            .then((refList) => {

                const extRef = refList.filter(
                    (ref) => ref.GeofenceId === this.selectedGeofence.Id
                );

                if (extRef) {
                    this.selectedGeofence.externalReferences = extRef;
                }

                this.loadingGeofences = false;
            });
    }

    private mapCenterValidateGeofence(geofence: IGeofence): boolean {

        if (geofence.Latitude == 0 && geofence.Longitude == 0)
            return false;

        if (geofence.isSystemGeofence)
            return false;

        if (geofence.Longitude < this.mapBounds.southwest.lng ||
            geofence.Longitude > this.mapBounds.northeast.lng ||
            geofence.Latitude < this.mapBounds.southwest.lat ||
            geofence.Latitude > this.mapBounds.northeast.lat)
            return false;

        return true;
        
    }
}

export class ResourceGeofencesComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
        };

        this.controller = Controller;
        this.template = require("./resourceGeofences.html");
    }
}
